import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiError } from '../../providers/ApiErrorProvider';
import { Auth } from 'aws-amplify';
import AcDialog from '../AcDialog/AcDialog';
import { sanitizeHtml } from '../../helpers/sanitizeHtml';

const AppSessionExpire = ({outlookAuthCodeChannel}) => {
    const apiError = useApiError();
    const { t } = useTranslation();
    const [sessionTimeoutInterval, setSessionTimeoutInterval] = useState<any>(null);
    const [showSessionExpireDialog,setShowSessionExpireDialog] = useState(false);
    const sessiontimeOutValue = useRef<string>();
    const timeout = useRef<number>();
    const SESSION_EXPIRING_TIMER = 14;

    const idleTime = useRef(0);
    const showSessionExpireDialogRef = useRef(false);
    showSessionExpireDialogRef.current = showSessionExpireDialog;

    const getUserInfo = async () => {
      try {
        const userData = await Auth.currentAuthenticatedUser();
        return userData ? 'Y' : 'N';
      } catch {
        return 'N';
      }
    }
    
    const decrementSessionTimeOutValue = async () => {
        if (timeout && timeout.current) {
          timeout.current--;
          let content = '';
          content = `As we detected no activity on this page, for secutiry reasons, your session will expire in: <br />${sessiontimeOutValue.current} min. <br />Do you want to extend the session?`
          sessiontimeOutValue.current = timeout?.current > 9 ? `00:${timeout.current}` : `00:0${timeout.current}`;
          const dialogDescription: HTMLElement | null = document.getElementById("acDialog__description");
          if (dialogDescription) {
            dialogDescription.innerHTML = sanitizeHtml(content);
          }
        }

        const isUserLoggedIn = await getUserInfo();
        //* identify 30 minutes inactivity
        if ((isUserLoggedIn === 'Y' && showSessionExpireDialog && timeout.current === 0) || isUserLoggedIn === 'N') {
          clearInterval(sessionTimeoutInterval);
          //* force logout steps
          idleTime.current = 0;
          setShowSessionExpireDialog(false);
          Auth.signOut().catch(() => undefined);
        }
    }

    useEffect(() => {
        const inactivityTimerIncrement = async () => {
            idleTime.current = idleTime.current + 1;
            const isUserLoggedIn = await getUserInfo();
            if(isUserLoggedIn === 'Y' && idleTime.current > SESSION_EXPIRING_TIMER && !showSessionExpireDialogRef.current){
              apiError.setErrorCode(0);
              setShowSessionExpireDialog(true);
            }
        }
        const resetIdleTime = () => {
            idleTime.current = 0;
        };
        const intervalId = window.setInterval(inactivityTimerIncrement, 60000);
        document.addEventListener('mousemove', resetIdleTime);
        document.addEventListener('keypress', resetIdleTime);
        return () => {
            window.clearInterval(intervalId);
            document.removeEventListener('mousemove', resetIdleTime);
            document.removeEventListener('keypress', resetIdleTime);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    const handleExtendSession = () => {
        setShowSessionExpireDialog(false);    
    }

    const handleLogout = () => {
        setShowSessionExpireDialog(false);
        idleTime.current = 0;
        outlookAuthCodeChannel.close();
        Auth.signOut().catch(() => undefined);
    }

    const popup = () => {
        return {
          icon: 'icon-circle-flight',
          title: t('sessionTimeOut.title'),
          description: t('sessionTimeOut.description'),
          actionLabel: t('sessionTimeOut.buttonText'),
          handleAction: handleLogout,
          secondaryActionLabel: t('sessionTimeOut.secondaryButtonText'),
          handleSecondaryAction: handleExtendSession,
        }
      }

    useEffect(()=>{
        if(!showSessionExpireDialog){
            if(sessionTimeoutInterval) clearInterval(sessionTimeoutInterval);
            timeout.current = 60;
            sessiontimeOutValue.current = '01:00';
        } else {
            const timeOutId = setInterval(decrementSessionTimeOutValue, 1000);
            setSessionTimeoutInterval(timeOutId);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[showSessionExpireDialog]);

    return (
        <AcDialog
            data={popup()}  
            onClose={handleExtendSession}
            open={showSessionExpireDialog}
        />
  );
};

export default AppSessionExpire;
